/**
 * CPV Q7 · report schedules' door to the server (`/bp/cpv/report-schedules/…`).
 *
 *   access()                     GET  …/access/            → {allowed}: may the person configure a schedule at a plant in view
 *   list()                       GET  …/                    → {results, words, configure_plants}
 *   options()                    GET  …/options/            → the drawer's choices (plants, sites, products, roles, people, graphs, …)
 *   detail(id)                   GET  …/<id>/               → the schedule, its fields, versions and recipients
 *   create(body)                 POST …/                    {plant?, name, content_kind, …}
 *   update(id, body)             POST …/<id>/update/        {…fields, reason, expected_version}
 *   pause(id, reason) / resume   POST …/<id>/pause/ | resume/ {reason}
 *   runNow(id)                   POST …/<id>/run-now/       → the schedule with `run` {queued, counts, message}
 *   deliveries(id, params)       GET  …/<id>/deliveries/    → one page of the delivery history
 *
 * Every POST carries its Idempotency-Key (cpvMasterApi.post). The client decides nothing: validation, who may act and
 * every refusal are the server's.
 */
import { get, post } from '../cpvMasterApi';

const BASE = '/cpv/report-schedules';

export const scheduleApi = {
  access: () => get(`${BASE}/access/`),
  list: () => get(`${BASE}/`),
  options: () => get(`${BASE}/options/`),
  detail: (id) => get(`${BASE}/${id}/`),
  create: (body) => post(`${BASE}/`, body),
  update: (id, body) => post(`${BASE}/${id}/update/`, body),
  pause: (id, reason) => post(`${BASE}/${id}/pause/`, { reason }),
  resume: (id, reason) => post(`${BASE}/${id}/resume/`, { reason }),
  runNow: (id) => post(`${BASE}/${id}/run-now/`, {}),
  deliveries: (id, params) => get(`${BASE}/${id}/deliveries/`, params),
};

/** The server's word for a code, else the code in plain words. */
export const wordOf = (words, vocab, code) => words?.[vocab]?.[code]
  || (code ? String(code).replace(/_/g, ' ').toLowerCase().replace(/^./, (c) => c.toUpperCase()) : '');
export const when = (iso) => (iso ? new Date(iso).toLocaleString() : '—');
